import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import media from './../../../common/MediaQueries'

const BrandAssetBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const BrandAssetBoxMediaStyled = styled.div`
  display: flex;
  margin-bottom: 2rem;
  @media ${media.maxPhone} {
    max-width: 16rem;
  }
  @media ${media.phone} {
    margin-bottom: 4.125rem;
    height: 31.25rem;
    width: 22.8125rem;
  }

  .lazy-load-image-loaded {
    display: flex;
  }

  img {
    width: auto;
  }
`

const BrandAssetBoxTitleStyled = styled(Text)`
  font-size: 1.0625rem;
  font-weight: 500;
  margin-bottom: 3.5rem;
  @media ${media.phone} {
    margin-bottom: 4.125rem;
  }
`

const BrandAssetBoxCtaStyled = styled.div``

export { BrandAssetBoxStyled, BrandAssetBoxMediaStyled, BrandAssetBoxTitleStyled, BrandAssetBoxCtaStyled }
